export default {
  pages: {
    createWarehouseItem: {
      title: "Mahsulot qo'shish",
    },
  },
};
